import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3 3.997v5.006c0 .55.447.997.997.997h5.006c.55 0 .997-.447.997-.997V3.997A.998.998 0 0 0 9.003 3H3.997A.998.998 0 0 0 3 3.997zm-1 0C2 2.894 2.896 2 3.997 2h5.006C10.106 2 11 2.896 11 3.997v5.006A1.998 1.998 0 0 1 9.003 11H3.997A1.998 1.998 0 0 1 2 9.003V3.997zm1 11v5.006c0 .55.447.997.997.997h5.006c.55 0 .997-.447.997-.997v-5.006A.998.998 0 0 0 9.003 14H3.997a.998.998 0 0 0-.997.997zm-1 0C2 13.894 2.896 13 3.997 13h5.006c1.103 0 1.997.896 1.997 1.997v5.006A1.998 1.998 0 0 1 9.003 22H3.997A1.998 1.998 0 0 1 2 20.003v-5.006zm12-11v5.006c0 .55.447.997.997.997h5.006c.55 0 .997-.447.997-.997V3.997A.998.998 0 0 0 20.003 3h-5.006a.998.998 0 0 0-.997.997zm-1 0C13 2.894 13.896 2 14.997 2h5.006C21.106 2 22 2.896 22 3.997v5.006A1.998 1.998 0 0 1 20.003 11h-5.006A1.998 1.998 0 0 1 13 9.003V3.997zM20 22v-1c.549 0 1-.45 1-.997v-5.006a.998.998 0 0 0-.997-.997h-5.006a.998.998 0 0 0-.997.997v5.006A1 1 0 0 0 15 21h5.023v1H20h.023H20zm.023-1L20 22h-5a2 2 0 0 1-2-1.997v-5.006c0-1.103.896-1.997 1.997-1.997h5.006c1.103 0 1.997.896 1.997 1.997v5.006c0 1.095-.89 1.984-1.977 1.997v-1z"
});

var SvgBrowse = function SvgBrowse(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgBrowse;